// extracted by mini-css-extract-plugin
export default {"videosTable":"GuBFUeMPFiaKZLvU4Lec"};